import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import KeysTable from './KeysTable';
import { wrapTemplateKey, type TemplateKeyRow } from '../keysUtils';
import { GENERAL_TEMPLATE_KEYS } from '../../model/buildObjectTemplateValueKeys';
import { getCurrencyI18nParams } from 'utils/helpers/currency/currencyHelpers';

interface GeneralKeysTabProps {
    onKeySelect?: (key: string) => void;
}

const GeneralKeysTab = ({ onKeySelect }: GeneralKeysTabProps) => {
    const { t } = useTranslation('TemplateValueKeys');
    const currencyParams = getCurrencyI18nParams();

    const rows = useMemo<TemplateKeyRow[]>(
        () =>
            GENERAL_TEMPLATE_KEYS.map((name) => ({
                key: wrapTemplateKey(name),
                value: t(`directory.general.${name}`, currencyParams),
            })),
        [t, currencyParams.baseCode, currencyParams.localName],
    );

    return <KeysTable rows={rows} onKeySelect={onKeySelect} />;
};

export default GeneralKeysTab;
